<template>
  <div class="container-fluid d-flex flex-column flex-grow-1 mt-3">
    <div class="animated fadeIn">
      <b-row>
        <b-col lg="12">
          <transition name="fade">
            <b-card no-body>
              <div slot="header">
                <i class="fa fa-edit"></i> {{ pageName }}
                <div class="card-header-actions">
                  <b-link class="card-header-action btn-minimize" v-b-toggle.collapse1>
                    <i class="icon-arrow-up"></i>
                  </b-link>
                </div>
              </div>
              <b-collapse id="collapse1" visible>
                <b-card-body>
                  <b-row>
                    <b-col sm="6">
                      <b-form-group>
                        <label class="text-black-50">Quiz Name</label>
                        <div>{{ item.quiz ? item.quiz.name : ''}}</div>
                      </b-form-group>
                    </b-col>
                    <b-col sm="6">
                      <b-form-group>
                        <label class="text-black-50">FirstName</label>
                        <div>{{ item.member ? item.member.firstName: ''}}</div>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="6">
                      <b-form-group>
                        <label class="text-black-50">ChatId</label>
                        <div>{{ item.member ? item.member.chatId : ''}}</div>
                      </b-form-group>
                    </b-col>
                    <b-col sm="6">
                      <b-form-group>
                        <label class="text-black-50">LastName</label>
                        <div>{{ item.member ? item.member.lastName : ''}}</div>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="6">
                      <b-form-group>
                        <label class="text-black-50">Username</label>
                        <div>{{ item.member ? item.member.username : ''}}</div>
                      </b-form-group>
                    </b-col>
                    <b-col sm="6">
                      <b-form-group>
                        <label class="text-black-50">Phone</label>
                        <div>{{ item.member ? item.member.phone : ''}}</div>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="12">
                      <table class="table table-bordered table-sm">
                        <thead class="thead-light">
                        <tr>
                          <th width="2%" scope="col" class="text-center">#</th>
                          <th width="30%" scope="col">Question</th>
                          <th width="15%" scope="col">Answer</th>
                          <th width="10%" scope="col">Correct Answer</th>
                          <th width="7%" scope="col">Point</th>
                          <th width="18%" scope="col">Start Date</th>
                          <th width="18%" scope="col">End Date</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(question, index) in item.items" :key="index">
                          <td class="text-center">
                            {{ index + 1 }}
                          </td>
                          <td>
                            <span v-if="question.question">{{ question.question.name }}</span>
                          </td>
                          <td>
                            <span v-if="question.answer">{{ question.answer.name }}</span>
                          </td>
                          <td>
                            <span>{{ question.correctAnswer ? 'Yes' : '-' }}</span>
                          </td>
                          <td>
                            <span>{{ question.point || 0 }}</span>
                          </td>
                          <td>
                            <span>{{ dateFormat(question.startDate) }}</span>
                          </td>
                          <td>
                            <span>{{ dateFormat(question.endDate) }}</span>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="4"></td>
                          <td>
                            <span class="font-weight-bold">Total: {{ totalPoint }}</span>
                          </td>
                          <td colspan="2"></td>
                        </tr>
                        </tbody>
                      </table>
                    </b-col>
                  </b-row>
                  <div class="d-flex justify-content-end">
                    <div class="form-actions">
                      <router-link type="cancel" class="btn btn-secondary" variant="secondary" :to="'/quiz/user-tries/' + $route.params.quizId">Cancel</router-link>
                    </div>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>
          </transition>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'QuizUserTriesSummaryPage',
  data () {
    return {
      item: {},
      totalPoint: 0
    }
  },
  created () {
    if (!this.$route.params.quizMemberId || this.$route.params.quizMemberId <= 0) {
      return
    }
    this.$loading.show()
    this.axios.get('quiz-member/item', {params: {quizMemberId: this.$route.params.quizMemberId}})
      .then(response => {
        this.item = response.data.data
        let totalPoint = 0
        this.item.items.forEach(function (item) {
          totalPoint += item.point || 0
        })
        this.totalPoint = totalPoint
        this.$loading.hide()
      })
      .catch(error => {
        this.$loading.hide()
        if (error.response && error.response.data.status === 400) {
          this.$toastr.error(error.response.data.message)
        }
      })
  },
  methods: {
    dateFormat (date) {
      return date ? moment(date).format('YYYY-MM-DD HH:mm:ss') : ''
    }
  },
  computed: {
    pageName () {
      return 'Member Quiz Summary'
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/quiz/QuizUserTriesSummaryPage.vue